import React from 'react';

/** Abstract stacked cards from the auth mock — decorative only. */
function AuthHeroIllus(): React.ReactElement {
  return (
    <div className="auth-hero__illus" aria-hidden>
      <div className="auth-hero__illus-card">
        <div className="auth-hero__illus-name" />
        <div className="auth-hero__illus-photo" />
      </div>
      <div className="auth-hero__illus-card">
        <div className="auth-hero__illus-name" />
        <div className="auth-hero__illus-photo" />
      </div>
      <div className="auth-hero__illus-card">
        <div className="auth-hero__illus-name" />
        <div className="auth-hero__illus-photo" />
      </div>
      <div className="auth-hero__illus-line" />
    </div>
  );
}

export default AuthHeroIllus;
